import { UrlConstants } from "../url.constants";
export class ApiEhInspectionActionTypeSurveyConstants {
    static URL = UrlConstants.API_V2 + "EhInspectionActionTypeSurvey";
    static FUNCTION_GET = "GET";
    static FUNCTION_GET_ACTION_TYPE_SURVEYS_FOR_INSPECTION = "GetActionTypeSurveysForInspection";
}
